import React from "react";

/**
 * Hook to save and return the previously rendered props
 *
 * @param {Object} props Props to save for the next render
 *
 * @see https://usehooks.com/usePrevious/
 */
export function usePrevious(props) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = React.useRef();

  // Store current value in ref
  React.useEffect(() => {
    ref.current = props;
  }, [props]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
